<template>
  <div ref="root" class="relative w-full custom_selected_body">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      @keyup.enter="enterSelect"
      @click="toggleShow"
      v-model="search"
      class="custom_select_input block w-full bg-white border border-gray-300 px-4 py-2 pr-8 rounded-2xl leading-tight focus:outline-none focus:shadow-outline"
      :class="{ 'custom_select_input--open': show }"
    >

    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-green-500">
      <svg
        v-if="show"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-chevron-up"
      >
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-chevron-down"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>

    <div
      v-if="show"
      class="blocked"
      @click="closeDropdown"
    ></div>

    <div
      v-if="show"
      class="drop_body_custom_select"
      :style="dropStyle"
    >
      <div
        v-for="(item, index) in view_array"
        :key="'custom-select-input-item-' + index"
        class="drop_body_custom_select__item pointer"
        @click="selectedItem(item)"
      >
        <span v-if="view && view != ''">{{ item[view] }}</span>
        <span v-else>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: {
    array: {
      default: () => [],
    },
    view: {
      type: String,
      default: '',
    },
    return: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Select...',
    },
    initialLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: null,
      show: false,
      view_array: [],
      result_this: null,
      dropStyle: {},
    };
  },
  methods: {
    enterSelect() {
      if (this.view_array.length === 1) {
        this.result_this = this.view_array[0];
        this.search = this.view && this.view != '' ? this.result_this[this.view] : this.result_this;
        this.closeDropdown();
        this.$emit('selected-item-in-custom-select', this.result_this);
      }
    },
    updateDropPosition() {
      const input = this.$refs.input;
      if (!input) {
        return;
      }
      const rect = input.getBoundingClientRect();
      this.dropStyle = {
        top: `${rect.bottom + 4}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
      };
    },
    toggleShow() {
      if (this.show) {
        this.closeDropdown();
        return;
      }
      this.updateDropPosition();
      this.show = true;
      this.$nextTick(() => {
        this.updateDropPosition();
      });
    },
    closeDropdown() {
      this.show = false;
    },
    selectedItem(item) {
      this.search = this.view && this.view != '' ? item[this.view] : item;
      this.closeDropdown();
      this.result_this = item;
      this.$emit('selected-item-in-custom-select', this.result_this);
    },
    testStr(val, str, res_array, key) {
      const test_str = str.toLowerCase();
      if (test_str.includes(val)) {
        res_array.push(this.array[key]);
      }
      return res_array;
    },
    async filteredArray(val) {
      let res_array = [];
      const searchVal = (val || '').toLowerCase();
      if (this.view && this.view != '') {
        for (const key in this.array) {
          const str = this.array[key][this.view];
          res_array = this.testStr(searchVal, str, res_array, key);
        }
      } else {
        for (const key in this.array) {
          const str = this.array[key];
          res_array = this.testStr(searchVal, str, res_array);
        }
      }
      return res_array;
    },
    onViewportChange() {
      if (this.show) {
        this.updateDropPosition();
      }
    },
  },
  watch: {
    async search(val) {
      this.view_array = await this.filteredArray(val);
    },
    initialLabel(val) {
      if (val) {
        this.search = val;
      }
    },
    array(val) {
      this.view_array = val;
      if (this.initialLabel) {
        this.search = this.initialLabel;
      }
    },
  },
  mounted() {
    this.view_array = this.array;
    if (this.initialLabel) {
      this.search = this.initialLabel;
    }
    window.addEventListener('scroll', this.onViewportChange, true);
    window.addEventListener('resize', this.onViewportChange);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onViewportChange, true);
    window.removeEventListener('resize', this.onViewportChange);
  },
};
</script>

<style lang="scss" scoped>
.custom_selected_body {
  z-index: 484;
}

.custom_select_input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.drop_body_custom_select {
  position: fixed;
  z-index: 500;
  max-height: 120px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #D0D5DA;
  border-top: none;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  scrollbar-color: #d0d5da #fff;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d5da;
    border-radius: 3px;
  }

  &__item {
    padding: 8px 12px;
    background: #fff;
    color: inherit;

    &:hover {
      color: #1fbc2f;
    }
  }
}

.blocked {
  position: fixed;
  inset: 0;
  z-index: 485;
}
</style>
